import { render, staticRenderFns } from "./ReferenceListPage.vue?vue&type=template&id=5d07dc8e&scoped=true&"
import script from "./ReferenceListPage.vue?vue&type=script&lang=js&"
export * from "./ReferenceListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07dc8e",
  null
  
)

export default component.exports